import api, { toUrlEncoded } from '@/api/baseApi';
import type {
    ExternalAuthResult,
    ExternalCheckoutResult,
    ExternalProvider,
    ExternalSignUpData
} from '@/typings/auth/externalAuth';

export const passwordLogin = async (username: string, password: string): Promise<void> => {
    await api.post('token', toUrlEncoded({ username, password, grant_type: 'password' }), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
};

/** Exchanges the single use ticket issued after a provider callback for a session. */
export const externalLogin = async (ticket: string): Promise<void> => {
    await api.post('token', toUrlEncoded({ ticket, grant_type: 'external_login' }), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
};

export const startExternalAuth = async (
    provider: ExternalProvider,
    intent: 'signup' | 'signin',
    storeType?: string,
    managedBy?: string
): Promise<string> => {
    const response = await api.get<{ authorizationUrl: string }>(`Auth/External/${provider}/Start`, {
        params: { intent, storeType, mngBy: managedBy }
    });
    return response.data.authorizationUrl;
};

export const completeExternalAuth = async (
    provider: ExternalProvider,
    code: string,
    state: string
): Promise<ExternalAuthResult> => {
    const response = await api.post<ExternalAuthResult>(`Auth/External/${provider}/Complete`, { code, state });
    return response.data;
};

export const completeExternalSignUp = async (signUp: ExternalSignUpData): Promise<ExternalAuthResult> => {
    const response = await api.post<ExternalAuthResult>('Auth/External/Signup/Complete', signUp);
    return response.data;
};

/** Called by the page a paid sign up checkout returns to, until the account verification is done. */
export const completeExternalCheckout = async (ticket: string): Promise<ExternalCheckoutResult> => {
    const response = await api.post<ExternalCheckoutResult>('Auth/External/Signup/Checkout/Complete', { ticket });
    return response.data;
};

export const sendPasswordResetEmail = async (email: string): Promise<void> => {
    await api.post(`Users/PasswordResetEmail?email=${encodeURIComponent(email)}`);
};
